const map = {
	"./clock.png": 7915,
	"./comentario.png": 6574,
	"./continue.png": 7998,
	"./create.png": 5661,
	"./flag.png": 2011,
	"./join-requested-primary.png": 1047,
	"./location.png": 2012,
	"./logo.png": 6928,
	"./people.png": 3436,
	"./peso.png": 2918,
	"./search.png": 1697,
	"./vertical_points.png": 7981
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;